function UseFormHookDemo() {
  return (
    <div>
      <h1>useForm Hook Demo</h1>
      <form>
        <label>
          Name:
          <input type="text" name="name" />
        </label>
        <br />
        <label>
          Email:
          <input type="email" name="email" />
        </label>
        <br />
        <button type="submit">Submit</button> 
      </form>
    </div>
  );
}

export default UseFormHookDemo;
